// extracted by mini-css-extract-plugin
export default {"menuBlock":"WE-z","title":"XE-z","nav":"YE-z","flexCell":"ZE-z","facetLink":"_E-z"};